function humanFileSize(size) {
  if (!size) return `${0} B`;
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return `${(size / Math.pow(1024, i)).toFixed(1) * 1} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
}

export default humanFileSize;
